export { default as Competitions } from './Competitions';
export { default as Events } from './Events';
export { default as PurchaseOrders } from './PurchaseOrders';
export { default as Tournaments } from './Tournaments';
export { default as Teams } from './Teams';
export { default as Workshops } from './Workshops';
export { default as TechnicalControl } from './TechnicalControl';
export { default as CsvImport } from './CsvImport';



// WEBPACK FOOTER //
// ./src/private/admin/containers/index.js